/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { NotImplementedFieldDisplay } from "./display";
import { NotImplementedFieldEdit } from "./edit";

const NotImplementedField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <NotImplementedFieldDisplay />,
        editComponent: <NotImplementedFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
NotImplementedField.displayName = "NotImplementedField";
export { NotImplementedField };
